module.exports = __webpack_public_path__ + "static/media/rei_active35c8e2f643b2d726eff96f09253ff629.webp";